// RND-10937: a PSP return URL can carry a "pending" verdict (maldopay landingPending, paycord pendingUrl,
// safecharge ppp_status=PENDING). `value === 'success'` turned those into a failed payment, so the trader
// saw "Payment Failed" on a payment that is still being processed.
const PENDING_VERDICTS = new Set([
    'pending',
    'processing',
    'in_progress',
    'in-progress',
    'inprogress',
    'waiting',
    'awaiting',
    'initiated',
    'initialized',
    'authorized',
]);

// true = approved, false = explicit non-success verdict (confirmed failure),
// null = no verdict yet (missing / empty / pending) - NEVER a failure.
export function pspReturnVerdict(value: unknown, approved: string | string[]): boolean | null {
    if (value === undefined || value === null) return null;
    const raw = String(value);
    const normalized = raw.trim().toLowerCase();
    if (normalized === '') return null;
    if (PENDING_VERDICTS.has(normalized)) return null;
    // Exact, case-sensitive match - same as the former `===` comparisons.
    return (Array.isArray(approved) ? approved : [approved]).includes(raw);
}
